module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"uploader-widget\">\n    <div class=\"filelist-items\">\n        ")
    ;  for (var i = 0; i < item.length; i++) if (!item[i].mime.match(/^image/)) { 
    ; __append("\n        ")
    ; __append( itemTemplate({item: item[i], url: url, widgetId: widgetId, readonly: readonly}) )
    ; __append("\n        ")
    ;  } 
    ; __append("\n    </div>\n    <div class=\"filelist-items-img\">\n        ")
    ;  for (i = 0; i < item.length; i++) if (item[i].mime.match(/^image/)) { 
    ; __append("\n        ")
    ; __append( imgItemTemplate({item: item[i], url: url, widgetId: widgetId, readonly: readonly}) )
    ; __append("\n        ")
    ;  } 
    ; __append("\n    </div>\n</div>\n")
  }
  return __output.join("");

}